import { AppRouteNamesList, IModuleRoute, RoleTypes } from 'models';
import { isRequiredRole } from './isRequiredRole';

export function filterNavbarRoutes(route: IModuleRoute, role: RoleTypes) {
	if (route.name === AppRouteNamesList.settings) {
		return false;
	}

	if (
		route.name === AppRouteNamesList.templates &&
		role !== RoleTypes.SUPER_ADMIN
	) {
		return false;
	}

	return isRequiredRole(role, route.requiredRoles);
}
